import { useLazyQuery } from '@apollo/client';

import { ProductKind } from 'types/api';
import { REFUND_POLICIES_BY_FILTER } from '..';
import { errorHandler } from 'utils/ErrorHandler';
import { ProductParamInput } from 'containers/ProductRegist/hooks/types';

export function useQueryGetRefundPolicyByFilter() {
  const [getRefundPolicyByFilter, { data }] = useLazyQuery(
    REFUND_POLICIES_BY_FILTER,
    { fetchPolicy: 'no-cache' },
  );

  const handleGetRefundPolicyByFilter = async (
    productParamInput: ProductParamInput,
    callback: (refundPolicyId: string) => void,
  ) => {
    try {
      let overseas =
        productParamInput.kind !== ProductKind.ONLINE &&
        productParamInput.frip.locationsOfVenue.some(item => item.overseas);

      if (
        productParamInput.frip.locationOfGathering &&
        productParamInput.frip.locationOfGathering.overseas
      ) {
        overseas = true;
      }

      const response = await getRefundPolicyByFilter({
        variables: {
          filter: {
            attachedSchedule: productParamInput.frip.attachedToSchedule,
            cancelingRestricted: productParamInput.cancelingRestricted,
            overseas,
            productKind: productParamInput.kind,
          },
        },
      });

      if (response.data) {
        const refundPolicyId = response.data.order.refundPolicesByFilter[0].id;

        callback(refundPolicyId);
      }
    } catch (error) {
      errorHandler(error);
    }
  };

  return { data, handleGetRefundPolicyByFilter };
}
